import { type MutationTree } from 'vuex';

import { type ISharedFieldCustomValueState } from './types';

export const RECEIVE_BY_LIST_ID = 'RECEIVE_BY_LIST_ID';

export const mutations: MutationTree<ISharedFieldCustomValueState> = {
    [RECEIVE_BY_LIST_ID](_state: ISharedFieldCustomValueState, { listId, idList }: { listId: number; idList: number[] }) {
        _state.byListId.set(listId, idList);
    }
};
